module.exports = __webpack_public_path__ + "static/media/header_contrato_v2.d5ab5c38.jpeg";